import React from 'react'
import { useState, useContext, useMemo, useEffect } from 'react';
import { Context } from '../../App';
import { useNavigate, useLocation } from 'react-router-dom';
import { db } from '../../config/firebase'
import ReactGA from "react-ga4";
import {
  getDocs,
  collection,
  query,
  where,
  orderBy,
  limit,
  arrayUnion,
  doc,
  getDoc,
  setDoc,
  Timestamp,
  updateDoc,
} from "firebase/firestore";

import { PiIdentificationCardLight } from "react-icons/pi";
import { MdOutlineDriveFileRenameOutline } from "react-icons/md";
import { VscWholeWord } from "react-icons/vsc";
import { FiSearch } from "react-icons/fi";

import Spinner from '../../components/Loading/TailSpin';
import MultiselectDropdown from '../../components/Dropdown/Multiselect';
import PopupAnimation from '../../components/animations/PopupAnimation';
import Checkbox from '../../components/Input/Checkbox';


function AddGroup({ }) {
  const navigate = useNavigate();

  const {
    generatedCodeC,
    nameC, } = useContext(Context);

  const [addingStatus, setAddingStatus] = useState(0);
  const [generatedCode, setGeneratedQrCode] = generatedCodeC
  const [name, setName] = nameC;
  const [desc, setDesc] = useState("");
  const [password, setPassword] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [isAddGroupOpen, setIsAddGroupOpen] = useState(false);
  const [innerSearch, setInnerSearch] = useState("")


  let generatedGroupId = useMemo(() => {
    let intermCode = "";
    for (let i = 0; i < 9; i++) {
      intermCode += ('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'.charAt(Math.floor(Math.random() * 62)))
    }
    setGeneratedQrCode(intermCode);
    // console.log(intermCode);
    return intermCode
  }, [])


  // ===================| MAIN PUSH |=================================================
  const handleAddGroup = async () => {
    setIsLoading(true);
    const enteredData = {
      name,
      desc,
      createdAt: Timestamp.now(),
      isIndividual: false,
      users: users.filter((item) => item.selected).map((item) => ({ uid: item.id, displayName: item.displayName }))
    }

    ReactGA.event({
      category: "Admin",
      action: "Add Group",
      label: localStorage.getItem("displayName"),
      value: name,
    });

    try {
      const docRef = doc(db, 'groups', generatedGroupId);

      await setDoc(docRef, enteredData);
      // console.log("Document Uploaded", enteredData);


      for (const user of users.filter((item) => item.selected)) {

        const userDocRef = doc(db, 'users', user.id);
        const docSnap = await getDoc(userDocRef);

        if (docSnap.exists()) {
          // console.log("Adding" + user.name + "to Group");
          await updateDoc(userDocRef, {
            groups: arrayUnion({ name, groupId: generatedGroupId, isPinned: false, isIndividual: false })
          });
        } else {
          // console.log("Error Adding" + user.name + "to Group");
        }
      }

      navigate('/GURU/add-group/code');
    } catch (error) {
      console.error("Error adding document: ", error);
    }
    setIsLoading(false)
  };

  const [openWrapper, setOpenWrapper] = useState(false);
  const [users, setUsers] = useState([
    // { uid: "232raf", name: "Lorem Ipsum", selected: false },
  ])

  useEffect(() => {

    const getUsersList = async (id) => {
      setIsLoading(true)
      try {
        const collectionRef = collection(db, 'users')
        // let q = query(collectionRef, where('submittedBy', '==', auth?.currentUser.uid));
        let q = query(collectionRef, orderBy("name"), limit(100));

        const data = await getDocs(q);
        const reqData = data.docs.map((item) => ({
          ...item.data(),
          id: item.id,
          selected: false
        }))
        setUsers(reqData);
        // setInvestorsMemo(reqData);
        // console.log(reqData);
      } catch (error) {
        // console.log(error);

      }
      setIsLoading(false)
    }

    setName("");
    getUsersList();

    ReactGA.send({ hitType: "pageview", page: "GURU/add-group", title: "Add Group" })
  }, [])

  const handleGroupSelection = (id) => {
    // console.log(id);
    setUsers((prev) => prev.map((item) => {
      if (item.id === id) return {
        ...item, selected: !item.selected
      }
      return item
    }
    ))
  }


  if (!isLoading)
    return (
      <div className='w-full h-full flex flex-col items-center justify-center p-6'>

        <div className="w-full md:w-[420px] p-6  bg-lightPrimary flex flex-col items-center rounded-lg ">
          <div className="text-3xl font-semibold text-headPrimary">Add Group</div>

          <div className="w-full grid grid-cols-1 gap-4 mt-7">

            <div className="flex justify-start w-full">
              <div className="border border-gray-300 bg-white text-gray-700 dark:bg-navy-900 dark:text-white z-1 flex h-[40px] md:h-[42px] w-full flex-grow items-left justify-start gap-2 rounded-md px-2.5 py-2.5 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:flex-grow-0 md:gap-1 xl:gap-2 w-full">
                <div className="flex h-full w-full items-center font-normal ">
                  <VscWholeWord
                    className="h-4 w-4 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                  <input
                    onChange={(e) => {
                      setName((e.target.value))
                    }}
                    value={name}
                    type="text"
                    placeholder="Group Name"
                    className="block ml-0 px-2 h-auto w-full rounded-full bg-white text-lg text-gray-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
                  />
                </div>

              </div>
            </div>

            <div className="flex justify-start w-full">
              <div className="border border-gray-300 bg-white text-gray-700 dark:bg-navy-900 dark:text-white z-1 flex h-[40px] md:h-[42px] w-full flex-grow items-left justify-start gap-2 rounded-md px-2.5 py-2.5 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:flex-grow-0 md:gap-1 xl:gap-2 w-full">
                <div className="flex h-full w-full items-center font-normal ">
                  <MdOutlineDriveFileRenameOutline
                    className="h-4 w-4 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                  <input
                    onChange={(e) => {
                      setDesc((e.target.value))
                    }}
                    value={desc}
                    type="text"
                    placeholder="Desc"
                    className="block ml-0 px-2 h-auto w-full rounded-full bg-white text-lg text-gray-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
                  />
                </div>

              </div>
            </div>


            <div className="flex justify-start w-full">
              <div
              onClick={() => { setIsAddGroupOpen(true) }}
              className="border border-gray-300 bg-white text-gray-700 dark:bg-navy-900 dark:text-white z-1 flex h-[40px] md:h-[42px] w-full flex-grow items-left justify-start gap-2 rounded-md px-2.5 py-2.5 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:flex-grow-0 md:gap-1 xl:gap-2 w-full">
                <div className="flex h-full w-full items-center font-normal ">
                  <PiIdentificationCardLight
                    className="h-4 w-4 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white mr-2.5" />
                  <div className="cursor-pointer hover:underline">Click to Add Users</div>
                </div>

              </div>
            </div>

          </div>


          <button
            onClick={handleAddGroup}
            className=" mt-5 flex items-center justify-center py-2 w-[100%] bg-white rounded-md border text-xl text-headPrimary hover:text-white hover:bg-headPrimary shadow-md hover:shadow-lg hover:font-bold">
            Create Group
          </button>

        </div>

        <PopupAnimation showDiv={isAddGroupOpen} >
          <div className="relative flex w-[90vw] h-[75vh] md:w-[382px] p-4 pt-4 md:p-5 flex-col justify-start rounded-xl bg-white shadow-lg outline-none dark:bg-navy-800 focus:outline-none">

            <button
              onClick={() => {
                setIsAddGroupOpen(false)
              }}
              type="button"
              className="bg-transparent absolute absolute top-0 right-0 h-fit w-fit p-2 items-center justify-center rounded-xl text-sm text-gray-400 ms-auto hover:bg-gray-200 hover:text-neuGray dark:hover:bg-gray-600 dark:hover:text-white"
              data-modal-hide="static-modal"
            >
              <svg
                className="h-3 w-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>

            <div className="text-2xl font-semibold text-center text-headPrimary"> Add Users to {name}</div>
            <div className='w-full h-[calc(100%-123px)] p-3 mt-6 flex flex-col bg-lightPrimary rounded-lg' >

              <div className=" h-fit w-[150px] ">
                <div className="border border-gray-300 bg-white text-gray-700 z-1 flex h-[30px] md:h-[28px] w-full flex-grow items-left justify-start gap-2 rounded-md px-1.5 py-0.5">
                  <div className="flex h-full w-full items-center font-normal ">
                    <FiSearch
                      className="h-3 w-3 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                    <input
                      onChange={(e) => {
                        setInnerSearch((e.target.value))
                      }}
                      value={innerSearch}
                      type="text"
                      placeholder="Search for Groups"
                      className="block ml-0 px-2 h-auto w-full bg-white text-sm text-gray-700 outline-none placeholder:!text-gray-400"
                    />
                  </div>

                </div>
              </div>

              <div className="w-full h-[calc(100%-42px)] overflow-y-auto mt-4 py-0 grid grid-cols-1">

                {users
                  .filter((item) => (item.name.toLowerCase().includes(innerSearch.toLowerCase())))
                  .map((item, ind) => (
                    <label  htmlFor={item.id + "BTN"}
                      // onClick={() => (handleGroupSelection(item.name))}
                      key={item.id + "BTN"} className={`flex w-full items-center ${item.selected ? "font-semibold" : ""} hover:font-bold ${ind % 2 ? "bg-gray-50" : "bg-white"} py-1 px-2 cursor-pointer group`}>

                      <Checkbox
                        checked={item.selected}
                        onChange={() => (handleGroupSelection(item.id))}
                        id={item.id + "BTN"} />

                      <div className="ms-2 flex flex-col text-left font-normal capitalize text-base hover:text-gray-800 dark:text-gray-300 group-hover:font-bold">
                        <div className="">{item.name}</div>
                        <div className="text-gray-600 text-xs">{item.id}</div>
                      </div>
                    </label >

                  ))}
              </div>
            </div>

            <div className="w-full flex items-center justify-center">

              <button
                onClick={() => { setIsAddGroupOpen(false) }}
                className=" mt-5 flex items-center justify-center py-2 w-[200px] bg-white rounded-md border text-xl text-headPrimary hover:text-white hover:bg-headPrimary shadow-md hover:shadow-lg hover:font-bold">
                ADD
              </button>


            </div>
          </div>
        </PopupAnimation>

      </div>
    )

  else return (<Spinner />)
}

export default AddGroup